import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../modules/filtering';
import { KCAL } from '../modules/constants';
import { Flags } from './flags';

function combineBastes(modifierOptionBastes, topLevelBastes) {
    return modifierOptionBastes
        .filter((item) =>
            isEmpty(
                topLevelBastes.find((baste) => baste.slug === item.slug)
                    .restaurantGroup
            )
        )
        .map((item) => {
            const { colour, nutritionalInfo, flags } = topLevelBastes.find(
                (baste) => baste.slug === item.slug
            );
            return {
                slug: item.slug,
                colour: colour ? colour : '#000',
                displayName: item.displayName,
                description: topLevelBastes.find(
                    (baste) => baste.slug === item.slug
                ).description,
                energyKcal: nutritionalInfo ? nutritionalInfo.energyKcal : 0,
                flags
            };
        });
}

/**
 * Currently unused bases information. Will display formatted messages about available bastes using keys from the API.
 *
 * @function
 * @param       {array} bastes list of bastes returned from the API for the menu item.
 * @constructor
 */
function Bastes({ baste, bastes, hideCalories, nandinos, toggle, title }) {
    if (!bastes || !baste) {
        return null;
    }

    const ourBastes = combineBastes(baste, bastes);

    if (nandinos) {
        ourBastes.reverse();
    }

    return (
        <>
            <h4 onClick={toggle} className='opener'>
                {title}
            </h4>
            <div className='panel'>
                {ourBastes.map(
                    (
                        { displayName, description, energyKcal, colour, flags },
                        idx
                    ) => {
                        return (
                            <React.Fragment key={`b-${idx}`}>
                                <div className='pdpspices'>
                                    <h5 style={{ color: colour.hexCode }}>
                                        <span>{displayName}</span>
                                        <Flags flags={flags} isForBaste={true} />
                                    </h5>
                                    <p> {description}</p>
                                    {hideCalories ? null : (
                                        <p>
                                            {energyKcal} {KCAL}
                                        </p>
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    }
                )}
            </div>
        </>
    );
}

Bastes.propTypes = {
    baste: PropTypes.array,
    bastes: PropTypes.array,
    hideCalories: PropTypes.bool,
    nandinos: PropTypes.bool,
    title: PropTypes.string,
    toggle: PropTypes.func
};

export { Bastes };
